import { Entity, MappedEntity, SnakeMeta } from '@api';
import { RangeHorizon } from '@chart';
import * as Radix from '@radix-ui/react-dropdown-menu';
import { ChartPreview } from '@terminal/modules/chart-preview/ChartPreview';
import { PosthogTrackingSource } from '@terminal/services/tracking/posthog/constants';
import React, { ReactNode, useState } from 'react';

export interface ChartPreviewDropdownProps
  extends Radix.DropdownMenuContentProps {
  children: ReactNode;
  enableHover?: boolean;
  entity: Entity | MappedEntity;
  horizon: RangeHorizon;
  snakeMeta?: SnakeMeta;
  source: PosthogTrackingSource;
}

export const ChartPreviewDropdown = ({
  children,
  entity,
  horizon,
  ...rest
}: ChartPreviewDropdownProps) => {
  const [open, setOpen] = useState(false);

  const onMouseEnter = () => {
    setOpen(true);
  };

  const onMouseLeave = () => {
    setOpen(false);
  };

  return (
    <Radix.Root open={open} onOpenChange={setOpen} modal={false}>
      <Radix.Trigger
        asChild
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
      >
        {children}
      </Radix.Trigger>
      <Radix.Portal>
        {open && (
          <ChartPreview
            horizon={horizon}
            entity={entity}
            onMouseLeave={onMouseLeave}
            onMouseEnter={onMouseEnter}
            {...rest}
          />
        )}
      </Radix.Portal>
    </Radix.Root>
  );
};
